//styles/commonStyles
export const flexCenter = (theme) => ({
  display: "flex",
  // flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  justifyContent: "space-between",
  gap: 2,
  width: "100%",
});

export const flexColumn = (theme) => ({
  display: "flex",
  flexDirection: "column",
});

export const buttonBase = (theme) => ({
  padding: theme.spacing(1, 3),
  transition: "all 0.3s ease",
  mr: 2,
  "&:last-child": {
    // If it's the last button, remove margin
    mr: 0,
  },
});

// Primary button
export const primaryButton = (theme) => ({
  ...buttonBase(theme),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  "&:hover": { backgroundColor: theme.palette.primary.dark },
});

// Secondary button
export const secondaryButton = (theme) => ({
  ...buttonBase(theme),
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  "&:hover": { backgroundColor: theme.palette.secondary.dark },
});

// Card styling
export const cardContainer = (theme) => ({
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(3),
});

export const listItemStyle = (theme) => ({
  marginBottom: theme.spacing(1.5),
});

export const imageStyle = (theme) => ({
  width: "240px",
  borderRadius: "16px",
  boxShadow: `0 4px 6px rgba(${theme.palette.background.paperRgb}, 0.1)`,
});

export const emailLink = {
  textDecoration: "none",
};

export const dangerButton = (theme, isMobile = false) => ({
  ...buttonBase(theme),
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.warning.contrastText,

  marginTop: isMobile ? 1 : 0,
  "&:hover": {
    color: theme.palette.warning.dark,
  },
});

export const imageContainer = (theme, isMobile) => ({
  width: isMobile ? "100%" : 400,
  height: "auto",
  maxWidth: "100%",
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
});

export const modalStyle = (theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  borderRadius: theme.shape.borderRadius,
  p: theme.spacing(4),
});

export const socialContainer = (theme) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  textAlign: "center",
  mt: theme.spacing(4),
});

export const socialIcon = (theme) => ({
  color: theme.palette.secondary.contrastText,
  "&:hover": { color: theme.palette.secondary.light },
});

export const specialFont = (theme) => ({
  fontFamily: theme.typography.logo.fontFamily,
});

export const paragraphIndent = (theme) => ({
  paddingLeft: theme.spacing(1.5),
});

export const layoutContainer = (theme) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
});

export const layoutContent = (theme) => ({
  flex: "1",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2, 0),
});

export const pageContainer = (theme) => ({
  flex: "1",
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const contentSection = (theme) => ({
  marginBottom: theme.spacing(3),
  "&:last-child": {
    marginBottom: 0,
  },
});
